// extracted by mini-css-extract-plugin
export default {"select":"JobPlacement_select__fccO0","wrapper":"JobPlacement_wrapper__s9ENd"};